import React from 'react'
import { useEffect, useState } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { getCountersByFarm, addRegisterCounter } from '../../actions/countersActions'
import { getFarms } from '../../actions/farmsActions'
import { useNavigate } from 'react-router-dom';
import Select from "react-select"
import customStyles from "../../components/design/select"
import jwtDecode from 'jwt-decode';
import Swal from 'sweetalert2';

export default function Cards() { 
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const navigate = useNavigate()

    let token = jwtDecode(sessionStorage.getItem('jwt'))

    const {farms} = useSelector((state) => state.farms)
    const {counters} = useSelector((state) => state.counters)
    const [farmsOptions, setFarmsOptions] = useState({options: null, selected: null})
    const [countersOptions, setCountersOptions] = useState({options: null, selected: null})
    const [inputHidden, setInputHidden] = useState(true)
    const [quantity, setQuantity] = useState(0)
    const [type, setType] = useState('kW h')
    

    useEffect(()=>{
        dispatch(getFarms())
    }, [dispatch])

    useEffect(()=>{
        let farmsAvailable = []
        let farmsSelected 

        farms?.forEach(farm => {
            let object = {value: farm._id, label: farm.name}
            farmsAvailable.push(object)
        })
        farmsSelected = farmsAvailable[farmsAvailable.length - 1]

        setFarmsOptions({options: farmsAvailable, selected: farmsSelected})
        dispatch(getCountersByFarm(farmsSelected?.value))
    },[farms, dispatch])

    const farmChange = (target)=>{
        let selectFarmOptions = []
        let selectedFarmOption

        farms?.forEach(farm => {
            let object = {value: farm._id, label: farm.name}
            selectFarmOptions.push(object)

            if(farm._id === target.value){
                selectedFarmOption = object
            }
        })
        setFarmsOptions({options: selectFarmOptions, selected: selectedFarmOption})
        dispatch(getCountersByFarm(selectedFarmOption.value))
    }

    useEffect(()=>{
        let countersAvailable = []
        let countersSelected = null

        counters?.forEach(farm => {
            let object = {value: farm._id, label: farm.name}
            countersAvailable.push(object)
            countersSelected = countersAvailable[countersAvailable.length - 1]
        })

        setCountersOptions({options: countersAvailable, selected: countersSelected})
    }, [counters])

    const counterChange = (target)=>{
        let selectCounterOptions = []
        let selectedCounterOption

        if(counters){
            counters?.forEach(counter => {
                let object = {value: counter._id, label: counter.name}
                selectCounterOptions.push(object)

                if(counter._id === target.value){
                    selectedCounterOption = object
                }
            })
            setCountersOptions({options: selectCounterOptions, selected: selectedCounterOption})
        }else{
            setCountersOptions({options: null, selected: null})
        }
    }

    useEffect(()=>{
        if(farmsOptions.selected !== null && countersOptions.selected !== null){
            setInputHidden(false)
        }else{
            setInputHidden(true)
        }
    }, [farmsOptions.selected, countersOptions.selected])

    const saveRegister = () => {
        dispatch(addRegisterCounter(quantity, token?.id, type, countersOptions.selected.value))
        setQuantity(0)
        Swal.fire({
            showConfirmButton: true,
            icon: 'success',
            text: t('counters.setregistersuccessful')
        })
    }

    const setQuantityValue = (target) => {
        setQuantity(target.target.value)
    }

    const setTypeValue = (target) => {
        setType(target.target.value)
    }

    const goBack = () => {
        navigate('/operator/dashboard')
    }

    return (
        <>
            <Container className='cuerpo'>
                <Row className="text-left custom-card-header">
                    <Row className="custom-card-buttom">
                        <Button className="btn btn-secondary mb-4 mx-auto" onClick={goBack}>
                            <i className="fas fa-arrow-circle-left"></i> {t('global.return')}
                        </Button>
                    </Row>
                    <h1>{t('counters.managecounters')}</h1>
                    <Form.Label className="form-label">{t('counters.selectaction')}</Form.Label>
                    <br/><br/><br/>
                    <Row className="text-center my-3">
                        <Col>
                            <Form.Group className="my-3">
                                <Form.Label>{t('counters.farm')}</Form.Label>
                                <Form.Group>
                                    <Select 
                                        onChange={farmChange}
                                        id='farm'
                                        placeholder={t('counters.farm')}
                                        options={farmsOptions.options}
                                        value={farmsOptions.selected}
                                        styles={customStyles}
                                    />
                                </Form.Group>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="my-3">
                                <Form.Label>{t('counters.counter')}</Form.Label>
                                <Form.Group>
                                    <Select onChange={counterChange}
                                        id='counter'
                                        placeholder={t('counters.counter')}
                                        options={countersOptions.options}
                                        value={countersOptions.selected}
                                        styles={customStyles}
                                    />
                                </Form.Group>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="text-center my-3">
                        <Col>
                            <Form.Group className="my-3">
                                { inputHidden
                                ?
                                    <></>
                                :
                                    <>
                                        <Form.Label>{t('counters.setregister')}</Form.Label>
                                        <Form.Group className="w-50">
                                            <Form.Control 
                                                onChange={setQuantityValue}
                                                id="setregister"
                                                className="form-control"
                                                type='text'
                                                name='register'
                                                value={quantity}
                                                placeholder={t('counters.register')}
                                            />
                                        </Form.Group>
                                        <Form.Group className="w-50">
                                            <Form.Control
                                                onChange={setTypeValue}
                                                as="select"
                                                id='type'
                                                name='type'
                                                placeholder={t('counters.type')}
                                            >
                                                <option value='kWh' defaultValue>{t('counters.kWh')}</option>
                                                <option value='L'>{t('counters.l')}</option>
                                                <option value='M³'>{t('counters.m3')}</option>
                                            </Form.Control>
                                        </Form.Group>
                                        <Button className="btn btn-secondary my-2 mx-auto" type="submit" onClick={saveRegister}><i className="fas fa-save"></i> {t('counters.registernew')}</Button>
                                    </>
                                }
                            </Form.Group>
                        </Col>
                    </Row>
                </Row>
            </Container>
        </>
    )
}


  
                
